import { useEffect, useState } from "react";
import { useRouterState } from "@tanstack/react-router";
import { useShallow } from "zustand/react/shallow";

import { usePlatform } from "~/hooks/use-platform";
import { usePermissionManager } from "~/managers/use-permission-manager";
import { usePreferencesStore } from "~/stores/use-preferences-store";
import { ScreenSaver } from "./screen-saver";

export const IdleTimer = () => {
  const { idleTimer, homePage, screensaverTimer } = usePreferencesStore(
    useShallow((state) => ({
      homePage: state.homePage,
      idleTimer: state.idleTimer,
      screensaverTimer: state.screensaverTimer,
    })),
  );
  const [idleTime, setIdleTime] = useState(0);
  const { platform } = usePlatform();
  const { logout } = usePermissionManager();

  const handleIdleReset = () => {
    setIdleTime(0);
  };

  const router = useRouterState();

  useEffect(() => {
    if (
      router.location.pathname.includes("reports") ||
      router.location.pathname.includes("settings")
    )
      return;
    const incrementIdleTime = () => {
      if (idleTime >= screensaverTimer) return;
      setIdleTime((prevIdleTime) => prevIdleTime + 1);
    };

    const events = ["mousemove", "keydown", "click", "scroll"];

    events.forEach((event) => window.addEventListener(event, handleIdleReset));

    const timer = setInterval(incrementIdleTime, 1000); // Increment idle time every second

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, handleIdleReset),
      );
      clearInterval(timer);
    };
  }, [idleTime, router.location, screensaverTimer]);

  useEffect(() => {
    if (idleTime >= idleTimer) {
      if (platform === "DESKTOP" || platform === "WEB") {
        logout();
      }
    }
  }, [idleTime, idleTimer, platform, homePage, logout]);

  if (
    idleTime >= screensaverTimer &&
    (platform === "DESKTOP" || platform === "WEB")
  ) {
    return <ScreenSaver />;
  }

  return null;
};
